import { useCallback } from 'react';
import { useDebouncedSave } from './use-debounced-save';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from '@/contexts/AuthContext';
import { toast } from 'sonner';

interface GridPreferenceData {
  columns: number;
}

export const useGridPreference = () => {
  const { user } = useAuth();

  const updateGridPreference = useCallback(async (data: GridPreferenceData) => {
    if (!user?.id) {
      console.error('No user ID available for updating grid preference');
      return;
    }

    try {
      const { error } = await supabase
        .from('profiles')
        .update({ grid_columns_preference: data.columns })
        .eq('user_id', user.id);

      if (error) {
        console.error('Error updating grid preference:', error);
        toast.error('Failed to save grid preference');
        return;
      }

      console.log('Grid preference saved successfully:', data.columns);
    } catch (error) {
      console.error('Error in updateGridPreference:', error);
      toast.error('Failed to save grid preference');
    }
  }, [user?.id]);

  const { saveNow } = useDebouncedSave({
    data: null, // Will be set when called
    onSave: updateGridPreference,
    delay: 1000,
    enabled: !!user?.id
  });

  const saveGridPreference = useCallback((columns: number) => {
    updateGridPreference({ columns });
  }, [updateGridPreference]);

  return { saveGridPreference, saveNow };
};